<ul>
  <ng-content select="f-facet[name=links],[facet-links],li[w-table-command-link]"
  description="provide links as a named facet of the component content"
  ></ng-content>
  <li class="b-flex-grow"><!-- spacer--></li>
  <ng-content select="f-facet[name=links-end],[facet-links-end],li[w-table-command-link-end]"
  description="provide content on the right as a named facet of the command table"
  ></ng-content>
</ul>
<ng-content select="f-facet[name=drawer],w-drawer" description="Optionally can contain w-drawer component(s)"></ng-content>
